import moment from 'moment-timezone';

const MomentSettingsInitializer = () => {
  moment.locale('en-US');
  moment.tz.setDefault('America/New_York');
};

export default MomentSettingsInitializer;
